import React from 'react';
import ClientLocation from './ClientLocation';

const ClientLocationBlockData = ({data, context}) => {
  return <ClientLocation data={data} context={context} />;
};
export default ClientLocationBlockData;
